import {
  Box,
  Button,
  Card,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { SubmitHandler, useForm } from "react-hook-form";
import { overlayVsStockEditModalStyles } from "../../../styles/OverlayVsStockChart.styles";

interface Props {
  isOpened: boolean;
  onClose: () => void;
  limit: number;
  onLimitChange: (limit: number) => void;
}

interface LimitInputs {
  limit: number;
}

export const OverlayVsStockEditModal = ({
  isOpened,
  onClose,
  limit,
  onLimitChange,
}: Props) => {
  const { register, handleSubmit, reset } = useForm<LimitInputs>({
    defaultValues: { limit },
  });

  const closeModal = () => {
    onClose();
    reset({ limit });
  };

  const handleFormSubmit: SubmitHandler<LimitInputs> = (data) => {
    onLimitChange(data.limit);
    closeModal();
  };

  useEffect(() => {
    reset({ limit });
  }, [limit, reset]);

  return (
    <Modal open={isOpened} onClose={closeModal}>
      <Stack height="100%" alignItems="center" justifyContent="center">
        <Box
          sx={overlayVsStockEditModalStyles.modalContainer}
          component="form"
          onSubmit={handleSubmit(handleFormSubmit)}
        >
          <Card>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <Typography variant="h5" component="h5" sx={{ padding: 1 }}>
                  Edit Chart Limit
                </Typography>
              </Grid>
              <Grid item>
                <IconButton onClick={closeModal} aria-label="Close modal">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <FormGroup>
              <FormControl sx={{ margin: 1 }}>
                <TextField
                  label="Limit (%)"
                  type="number"
                  inputProps={{ step: "0.01", min: "0.01" }}
                  {...register("limit", {
                    required: true,
                    valueAsNumber: true,
                    min: {
                      value: 0.01,
                      message: "Limit must be greater than 0",
                    },
                  })}
                  helperText={`Current limit: ${limit.toFixed(2)}%`}
                />
              </FormControl>
              <Box sx={overlayVsStockEditModalStyles.buttonsContainer}>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={closeModal}
                  sx={overlayVsStockEditModalStyles.button}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={overlayVsStockEditModalStyles.button}
                >
                  Save
                </Button>
              </Box>
            </FormGroup>
          </Card>
        </Box>
      </Stack>
    </Modal>
  );
};
